import { render, staticRenderFns } from "./GrowUpDialog.vue?vue&type=template&id=46db71fa&scoped=true"
import script from "./GrowUpDialog.vue?vue&type=script&lang=js"
export * from "./GrowUpDialog.vue?vue&type=script&lang=js"
import style0 from "./GrowUpDialog.vue?vue&type=style&index=0&id=46db71fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db71fa",
  null
  
)

export default component.exports